import styles from '../../css/landing/bar.module.css'

const Bar = () => {
    return ( 
        <div style={{marginTop: '-40px'}} className={styles.bar}></div>
     );
}
 
export default Bar;